import { render } from "./d-desk.vue?vue&type=template&id=2d19a3f7&scoped=true&ts=true"
import script from "./d-desk.vue?vue&type=script&lang=ts"
export * from "./d-desk.vue?vue&type=script&lang=ts"

import "./d-desk.vue?vue&type=style&index=0&id=2d19a3f7&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d19a3f7"]])

export default __exports__